import Spinner from 'common/Spinner'

type MessageLoaderProps = {
  message: string
  containerClass?: string
}

const MessageLoader: React.FC<MessageLoaderProps> = ({
  message,
  containerClass,
}) => (
  <div className={`${containerClass} flex-center`}>
    <span className="~mr-4 fs-18">{message}</span>
    <Spinner />
  </div>
)

export default MessageLoader
